import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { POLLING_INTERVAL_MS } from "../../constants/polling-constants";
import { queryKeys } from "../../lib/queryKeys";
import { getCDIAlerts, getCDIAlertsV2, getVBCAlerts } from "../../services";

export const useVBCAlerts = (
  mrn?: string,
  options?: { polling?: boolean; enabled?: boolean }
) => {
  const polling = options?.polling ?? false;
  const enabled = options?.enabled ?? Boolean(mrn);

  return useQuery({
    queryKey: queryKeys.vbcAlerts(mrn ?? ""),
    queryFn: () =>
      getVBCAlerts({
        params: { mrnNo: mrn! },
      }),
    enabled: enabled && Boolean(mrn),
    placeholderData: keepPreviousData,
    refetchInterval: polling ? POLLING_INTERVAL_MS : false,
    retry: (failureCount, error: any) => {
      if (error?.response?.status === 404) return false;
      return failureCount < 1;
    },
  });
};

export const useCDIAlerts = (
  params: Record<string, unknown>,
  enabled = true
) =>
  useQuery({
    queryKey: queryKeys.cdiAlerts(params),
    queryFn: () => getCDIAlerts({ params }),
    enabled,
  });

export const useCDIAlertsV2 = (
  params: Record<string, unknown>,
  options?: { polling?: boolean; enabled?: boolean }
) => {
  const polling = options?.polling ?? false;
  const enabled = options?.enabled ?? true;

  return useQuery({
    queryKey: queryKeys.cdiAlertsV2(params),
    queryFn: () => getCDIAlertsV2({ params }),
    enabled,
    placeholderData: keepPreviousData,
    refetchInterval: polling ? POLLING_INTERVAL_MS : false,
  });
};
